import React from "react";
import samplePDF from "./standardy.pdf"; 

const PdfPreview = () => {
  return (
    <div style={{ width: "100%", height: "80vh" }}>
      <iframe
        src={samplePDF}
        title="Podgląd PDF"
        width="100%"
        height="100%"
        style={{ border: "none" }}
      />
    </div>
  );
};

export default PdfPreview;
